import {
  Card,
  CardContent,
  Typography
} from '@material-ui/core';
import { observer } from 'mobx-react';
import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';

@observer
export class NotAuthorised extends React.Component<InjectedIntlProps, {}> {

  public componentDidMount() {
    const { formatMessage } = this.props.intl;
    document.title = formatMessage({id: 'app.title'});
  }

  public render() {
    const { formatMessage } = this.props.intl;

    return (
      <Card>
        <CardContent>
          <Typography variant="h5">
            {formatMessage({id: 'notauthorised.title'})}
          </Typography>
          <Typography color="textSecondary">
            {formatMessage({id: 'notauthorised.hint'})}
          </Typography>
        </CardContent>
      </Card>
    );
  }
}


export default injectIntl(NotAuthorised);


// WEBPACK FOOTER //
// ./src/app/NotAuthorised.tsx